var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcClearInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#918F93"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52876 7.52827C7.78911 7.26792 8.21122 7.26792 8.47157 7.52827L12.0002 11.0569L15.5288 7.52827C15.7891 7.26792 16.2112 7.26792 16.4716 7.52827C16.7319 7.78862 16.7319 8.21073 16.4716 8.47108L12.943 11.9997L16.4716 15.5283C16.7319 15.7886 16.7319 16.2107 16.4716 16.4711C16.2112 16.7314 15.7891 16.7314 15.5288 16.4711L12.0002 12.9425L8.47157 16.4711C8.21122 16.7314 7.78911 16.7314 7.52876 16.4711C7.26841 16.2107 7.26841 15.7886 7.52876 15.5283L11.0574 11.9997L7.52876 8.47108C7.26841 8.21073 7.26841 7.78862 7.52876 7.52827Z",
    fill: "#FDFDFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClearInput);
export default __webpack_public_path__ + "static/media/ic-clear-input.da8bb68a68899fdf4c62e71425b3f337.svg";
export { ForwardRef as ReactComponent };